<div class="fridge-container d-flex justify-content-end align-items-center">

  <div *ngIf="accessPassesService.getLoading() | async" class="spinner-border text-light" role="status">
    <span class="sr-only">Loading...</span>
  </div>

  <h2 *ngIf="fridges?.length < 2; else mpupSelect">{{selectedFridge?.fridgeDescription}}</h2>

  <ng-template #mpupSelect>
    <select (change)="onSelectFridge($event.target.value)">
      <option *ngFor="let fridge of fridges" [value]="fridge.fridgeId">{{fridge.fridgeDescription}}</option>
    </select>
  </ng-template>

  <img
    *ngIf="selectedFridge !== null"
    src="assets/images/Icon_congress-location-white.svg"
    alt="fridge-location"
    [ngbTooltip]="getLocation()"
  />
</div>
